import { Dispatch } from "redux";
import { createRequestActionTypes } from "../../../../../utils/request-actions-helpers/createRequestActionTypes";
import { ApiConfig } from "../../../../../config/ApiConfig";
import { AppStateWithData } from "../../../../AppStateWithData";
import { RequestThunkParameters, createRequestThunk } from "../../../../../utils/request-actions-helpers/createRequestThunk";
import { Message } from "../../../../../models";
import { processMessagesResponse } from "./processMessagesResponse";

export interface GetMessagesAdditionalData {
    chatUId: string,
    messagesPage?: number,
}

export const getChatMessagesActionTypes = createRequestActionTypes('GET_CHAT_MESSAGES')

export const getChatMessages = (config: ApiConfig) => (chatUId: string, page: number) => (dispatch: Dispatch, getState: () => AppStateWithData) => {
    const thunkParams: RequestThunkParameters<Message[], never, GetMessagesAdditionalData> = {
        method: 'GET',
        requestActionTypes: getChatMessagesActionTypes,
        url: `${config.API_URL}/chat/getChatMessages?chatUid=${chatUId}&page=${page}`,
        actionAdditionalData: {
            chatUId,
            messagesPage: page
        },
        processResultBeforeDispatch: processMessagesResponse
    }

    return dispatch<any>(createRequestThunk(thunkParams))
}

